import {FormButtonType, FormControlType, IFormConfig, InputType, ValidationRules} from 'marine-panel-common-web';

export const addArticleFormConfig = (dismissModal: () => void): IFormConfig => ({
    controlType: 'form',
    class: 'default-form search-form',
    dataAccessor: (data: any) => data,
    outputDataMapper: (data: any, previousStateSnapshot: any) => {
        Object.assign(previousStateSnapshot, data);
        return previousStateSnapshot;
    },
    controls: [
        {
            key: 'title',
            controlType: 'group',
            class: 'row custom-row',
            controls: {
                title: {
                    controlType: 'control',
                    defaultValue: '',
                    formControlType: FormControlType.INPUT,
                    validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                    placeholder: 'articles.addArticleModal.form.placeholders.title',
                    isLabelHidden: false,
                    label: 'articles.addArticleModal.form.labels.title',
                    type: InputType.TEXT,
                    hostClass: 'col-xl-12 form-control',
                },
            },
        },
        {
            key: 'subtitle',
            controlType: 'group',
            class: 'row custom-row',
            controls: {
                subtitle: {
                    controlType: 'control',
                    defaultValue: '',
                    formControlType: FormControlType.INPUT,
                    validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                    placeholder: 'articles.addArticleModal.form.placeholders.subtitle',
                    isLabelHidden: false,
                    label: 'articles.addArticleModal.form.labels.subtitle',
                    type: InputType.TEXT,
                    hostClass: 'col-xl-12 form-control',
                },
            },
        },
        {
            key: 'description',
            controlType: 'group',
            class: 'row custom-row',
            controls: {
                description: {
                    controlType: 'control',
                    defaultValue: '',
                    formControlType: FormControlType.INPUT,
                    validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                    placeholder: 'articles.addArticleModal.form.placeholders.description',
                    label: 'articles.addArticleModal.form.labels.description',
                    type: InputType.TEXT,
                    hostClass: 'col-xl-12 form-control',
                },
            },
        },
        {
            key: 'content',
            controlType: 'group',
            class: 'row custom-row',
            controls: {
                content: {
                    controlType: 'control',
                    defaultValue: '',
                    formControlType: FormControlType.RICHTEXT,
                    validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                    placeholder: 'articles.addArticleModal.form.placeholders.content',
                    label: 'articles.addArticleModal.form.labels.content',
                    type: InputType.TEXT,
                    hostClass: 'col-xl-12 form-control',
                },
            },
        },
        {
            controlType: 'group',
            key: 'add_article_modal_buttons',
            class: 'row justify-content-end',
            controls: {
                previousButton: {
                    buttonName: 'cancel',
                    controlType: 'control',
                    formControlType: FormControlType.BUTTON,
                    buttonType: FormButtonType.BUTTON,
                    inputStyles: 'btn btn-underline btn-underline-primary d-flex align-items-center',
                    hostClass: 'mb-0 w-auto',
                    disabled: false,
                    defaultContainerStyles: '',
                    containerStyles: '',
                    defaultValue: null,
                    btnText: 'buttons.cancel',
                    buttonDisabled: () => {
                        return false;
                    },
                    customClickHandler: () => {
                        return dismissModal();
                    },
                },
                submitButton: {
                    buttonName: 'submit',
                    controlType: 'control',
                    formControlType: FormControlType.BUTTON,
                    buttonType: FormButtonType.SUBMIT,
                    inputStyles: 'btn-submit btn-create d-flex align-items-center',
                    hostClass: 'mb-0 align-items-end w-auto',
                    defaultContainerStyles: '',
                    containerStyles: '',
                    defaultValue: null,
                    btnText: 'buttons.submit',
                    buttonDisabled: (mappedOutputValue: any, isFormValid: boolean) => {
                        return !isFormValid;
                    },
                },
            },
        },
    ],
});
